module.exports = __webpack_public_path__ + "img/public-icon.a7499318.svg";